import { useEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

import { status } from 'constants/general';

import { SnackBarWrapper, SnackBarContent, SnackBarMessage, CloseIcon } from './SnackBar.style';

const SnackBar = ({ show, message, messageType, onHide }) => {
  const themeContext = useContext(ThemeContext);
  const { colors } = themeContext;
  const { redMain, greenMain } = colors;

  const timeoutTimer = useRef();

  useEffect(() => {
    if (show) {
      clearTimeout(timeoutTimer?.current);
      timeoutTimer.current = setTimeout(() => {
        onHide();
      }, 3000);
    }
  }, [onHide, show]);

  return (
    <SnackBarWrapper
      show={show}
      color={messageType === status.FAIL ? redMain : greenMain}
      data-testid="snack-bar-wrapper"
    >
      <SnackBarContent>
        <SnackBarMessage isFailMessage={messageType === status.FAIL}>{message}</SnackBarMessage>
        <CloseIcon onClick={() => onHide()} data-testid="snack-bar-close-icon" />
      </SnackBarContent>
    </SnackBarWrapper>
  );
};

SnackBar.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  messageType: PropTypes.oneOf([status.SUCCESS, status.FAIL]).isRequired,
  onHide: PropTypes.func.isRequired,
};

SnackBar.defaultPtops = {};

export default SnackBar;
